import React, { useEffect, useRef, useState } from 'react'
import { newSessionMutation } from './InHouseGame'
import {
  Currency,
  InHouseGame2CreateInHouseSessionMutation,
} from './__generated__/InHouseGame2CreateInHouseSessionMutation.graphql'
import { commitMutation } from 'relay-runtime'
import Env from './../../RelayEnvironment'
import { store } from '@src/store'
import { AppLoader } from '@src/components/AppLoader/AppLoader'
import { useSimpleStrapiFetch } from '../Strapi/Strapi.hook'
import StrapiSEO from '../Strapi/Strapi.SEO'
import { components } from '../Strapi/Strapi.api.types'

const Plinko = ({ dynamic }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [sourceDetails, setSourceDetails] = useState<any>(null)
  const walletStore = store.getState().wallet
  const [activeWallet, setActiveWallet] = useState(walletStore?.activeWallet)
  const [externalComponent, setExternalComponent] = useState<any>(null)

  const { data, loading, error } = useSimpleStrapiFetch<components['schemas']['GamePageListResponse']>({
    collection: 'game-pages',
    populate: ['SEO'],
    filters: { gameId: 'plinko99' },
  })

  const gamePage = !loading && !error && data && data.data && data.data.length > 0 ? data.data[0] : null
  const seo = gamePage ? gamePage.SEO : null

  const loadPlinko = async (sourceAddress: string, sourceBundle: string, sessionId: string) => {
    const PlinkoModule: React.FC<{ sourceAddress: string; sessionId: string }> = (
      await import(
        /* @vite-ignore */
        `${sourceAddress + sourceBundle}`
      )
    ).default
    setExternalComponent(() => <PlinkoModule sourceAddress={sourceAddress} sessionId={sessionId} />)
  }

  const updatePlinkoSource = (activeWallet) => {
    commitMutation<InHouseGame2CreateInHouseSessionMutation>(Env, {
      mutation: newSessionMutation,
      variables: {
        input: {
          gameCode: 'bjfun:plinko',
          currency: activeWallet.currency as Currency,
          virtualId: activeWallet.virtualId,
        },
      },
      onCompleted: ({ createInHouseSession }) => {
        if (createInHouseSession) {
          if (dynamic) {
            loadPlinko(
              createInHouseSession.parameters.host,
              createInHouseSession.parameters.bundle,
              createInHouseSession.sessionId
            )
          } else {
            setSourceDetails(createInHouseSession)
          }
        }
      },
      onError: (err: any) => {
        console.error(err)
      },
    })
  }

  useEffect(() => {
    if (activeWallet?.currency !== walletStore.activeWallet?.currency) {
      setActiveWallet(walletStore.activeWallet)
      updatePlinkoSource(walletStore.activeWallet)
    }
  }, [walletStore.activeWallet?.currency])

  useEffect(() => {
    if (activeWallet && !sourceDetails) {
      updatePlinkoSource(activeWallet)
    }
  }, [activeWallet])

  return (
    <>
      <StrapiSEO seo={seo} />

      {dynamic ? (
        externalComponent!
      ) : (
        <>
          {sourceDetails ? (
            <iframe
              key="bjfun-plinko-iframe"
              ref={iframeRef}
              title="plinko"
              src={`${sourceDetails.parameters.host}?session_id=${sourceDetails.sessionId}`}
              allowFullScreen
              className={'w-full'}
              style={{
                height: `calc(100dvh - 90px)`,
                width: '100%',
              }}
            />
          ) : (
            <AppLoader />
          )}
        </>
      )}
    </>
  )
}

export default Plinko
